import { defineIntegration, consoleSandbox } from '@sentry/core';
import { createSentryPiniaPlugin } from '@sentry/vue';

const INTEGRATION_NAME = 'Pinia';

const _piniaIntegration = ((
  // `unknown` here as well because usePinia declares this type: `export declare const usePinia: () => unknown;`
  pinia,
  options = {},
) => {
  return {
    name: INTEGRATION_NAME,
    setup() {
      if (!pinia || (typeof pinia === 'object' && !('use' in pinia))) {
        consoleSandbox(() => {
          // eslint-disable-next-line no-console
          console.warn(
            '[Sentry] The Pinia integration was added, but the passed parameter `pinia` has the wrong value. Make sure to enable Pinia by adding `"@pinia/nuxt"` to the Nuxt modules array and pass pinia to Sentry with `piniaIntegration(usePinia())`. Current value of `pinia`:',
            pinia,
          );
        });
      } else {
        (pinia ).use(createSentryPiniaPlugin(options));
      }
    },
  };
}) ;

/**
 * Monitor an existing Pinia store.
 *
 * This only works if "@pinia/nuxt" is added to the `modules` array.
 */
const piniaIntegration = defineIntegration(_piniaIntegration);

export { piniaIntegration };
//# sourceMappingURL=piniaIntegration.js.map
